// RECRUITER CALL — read a single call row + its transcript + AI analysis.
// path: GET /v3/recruiter-calls/{id}
// ***************************************************************************
import { useSwrApi } from '@hooks/useSwrApi/useSwrApi';
import type { RecruiterCallView } from '@type/recruiter-call';

interface UseSwrRecruiterCallProps {
  id?: number | null;
  shouldFetch?: boolean;
}

/**
 * @description SWR: read one RecruiterCall row (voter-guarded on backend).
 * Poll while `transcript` is null after the recording arrives — see the
 * post-call view for the polling pattern.
 */
export const useSwrRecruiterCall = (props: UseSwrRecruiterCallProps) => {
  const { id, shouldFetch = true } = props;

  const {
    data, error, isLoading, isValidating, mutate,
  } = useSwrApi<RecruiterCallView>({
    url: `/v3/recruiter-calls/${id}`,
    shouldFetch: shouldFetch && Boolean(id),
    apiOptions: {
      revalidateOnFocus: false,
    },
  });

  return {
    data,
    error,
    mutate,
    isLoading,
    isValidating,
  };
};
